module.exports = __webpack_public_path__ + "img/LogoRSSBO_Header.d1e5ef8c.svg";